<template>
  <BaseRoundButton
    class="download-all-documents-button"
    :size="36"
    is-transparent
    icon="download"
    :tooltip-text="$t('page.opportunity-details.document-manipulations.download-all')"
    tooltipPlacement="top"
    :is-loading="downloading"
    @click.native="downloadAll"
  />
</template>

<script>
import BaseRoundButton from '@/components/base/BaseRoundButton.vue';
import { opportunityDocumentsService } from '@/services/opportunity-documents.service';
import { downloadBlob } from '@/util/download-file';

// Saves all the opportunity's documents in one .zip, which the server builds.
export default {
  name: 'DownloadAllDocumentsButton',
  components: { BaseRoundButton },
  props: {
    opportunity: { type: Object, required: true },
  },
  data() {
    return { downloading: false };
  },
  computed: {
    zipName() {
      return `${this.opportunity.name || this.opportunity.id} - ${this.$t('tender-details.documents')}.zip`;
    },
  },
  methods: {
    downloadAll() {
      if (this.downloading) return Promise.resolve();
      this.downloading = true;
      return opportunityDocumentsService
        .getAllDocumentFiles({ opportunityId: this.opportunity.id })
        .then((zip) => downloadBlob(zip, this.zipName))
        .catch(() => this.$toast.error(this.$t('page.opportunity-details.document-manipulations.download-all-fail')))
        .finally(() => {
          this.downloading = false;
        });
    },
  },
};
</script>
